import { render, staticRenderFns } from "./PortalTable.vue?vue&type=template&id=5b820b09&"
import script from "./PortalTable.vue?vue&type=script&lang=js&"
export * from "./PortalTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports